import React from 'react';
import * as Types from 'types';

import { MaskedImage } from 'components/MaskedImage';
import { ArtworkPreviewPlayer } from 'player/ArtworkPreviewPlayer';
import { DeviceArtworkTitle } from 'playlists/components/PlaylistHero/DeviceArtworkTitle';
import { getMaskedImageConfigForInterior } from 'playlists/components/PlaylistHero/getMaskedImageConfigForInterior';

type StateProps = {
  artwork: Types.Artwork;
};

type DispatchProps = {};

type OwnProps = {};

type Props = OwnProps & DispatchProps & StateProps;

export const InteriorScene: React.FC<Props> = ({ artwork }) => {
  const interior = 'lounge';

  if (!artwork) {
    return null;
  }

  return (
    <div className='playlist-hero page-hero align-items-end pos-rel interior-scene'>
      <MaskedImage {...getMaskedImageConfigForInterior(interior)}>
        <div className='pos-rel w-100 h-100'>
          <DeviceArtworkTitle interior={interior} artwork={artwork} showArtistName />
          <div className='default-transition stretch'>
            <ArtworkPreviewPlayer artworkId={artwork.id} initialize={true} />
          </div>
        </div>
      </MaskedImage>
      <div className='scene-description container-fluid pb-2 pt-4 pb-md-2 pt-md-8 bg-gradient-into-dark pos-rel text-light'>
        <div className='row mx-auto align-items-end container'>
          <p className='standfirst standfirst--lead mx-auto mb-0 lh-regular pos-rel text-md-left'>
            NFTs to enjoy - not just trade. Display your art on screens in your house or home
            office. Use one of our many apps and give your NFT artworks the high quality display
            they deserve.
          </p>
        </div>
      </div>
    </div>
  );
};
